import { Loadable } from '../Loadable';

export { CardInputBraintree, CardInputFreedomPay, AddPaymentMethods } from './components';
export const AsyncPaymentMethodsList = Loadable(() => import('./PaymentMethodsList'));
export const AsyncReenterCreditCard = Loadable(() => import('./ReenterCreditCard'));
export const AsyncAddCreditCard = Loadable(() => import('./AddCreditCard'));
